import React from "react";
import cx from "classnames";
import styles from "../../scss/AFDialog.module.scss";
import LModal from "../../../common/components/Modals/LModal/LModal";
import Button from "../../../common/components/Forms/Button/Button";

interface IAFSkipPaymentDialog {
    isOpen: boolean;
    acknowledge: () => void;
    onClose: (isContinue: boolean) => void;
}

const AFSkipPaymentDialog: React.FC<IAFSkipPaymentDialog> = (props) => {
    const { isOpen, acknowledge, onClose } = props;

    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="normal"
            removePadding={true}
            isOpen={isOpen}
            onClose={() => onClose(false)}>
            {() => {
                return (
                    <div className={cx(styles["af-warning-dialog-modal"])}>
                        <div className={styles["af-warning__header"]}>
                            <h2>Disclaimer</h2>
                        </div>
                        <div className={styles["af-warning__content"]}>
                            <p className={styles["af-warning__desc"]}>
                                By choosing "organise later", you will be ineligible for interim cover with your selected insurer. Interim cover is only available when payment details are provided as part of your application.</p>
                            <p>
                                If at any stage you wish to provide your payment details prior to your policy commencing to take advantage of the insurers interim cover, please let us know and we can get that sorted.
                            </p>

                            <Button
                                className={styles["af-warning__continue"]}
                                width="fill"
                                component="button"
                                size="s"
                                onClick={() => acknowledge()}
                                variant="calltoaction">
                                <span>I understand</span>
                            </Button>
                        </div>
                    </div>
                );
            }}
        </LModal>
    );
};

export default AFSkipPaymentDialog;
